export default __webpack_public_path__ + "static/media/bag15.27a90076.jfif";